export const NODE_ENV = process.env.NODE_ENV ?? '';
export const WEB_API_URL = process.env.REACT_APP_WEB_API_URL ?? '';
export const AUTH_API_URL = process.env.REACT_APP_AUTH_API_URL ?? '';
export const REACT_APP_WEB_API_URL = process.env.REACT_APP_WEB_API_URL ?? '';
export const REACT_APP_PERFORMANCE_PAGE_URL =
  process.env.REACT_APP_PERFORMANCE_PAGE_URL ?? '';
